import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as ErrorActions } from "../../../store/ducks/error";
import { Creators as SuccessActions } from "../../../store/ducks/success";
import Dropzone from "react-dropzone";
import Cropper from "cropperjs";
import PrimaryButton from "../../PrimaryButton";
import DefaultButton from "../../DefaultButton";
import api from "../../../services/api";
import apiChat from "../../../services/apiChat";
import { Creators as PermissionsActions } from "../../../store/ducks/permissions";

class Photo extends Component {
  state = {
    accepted: [],
    rejected: [],
    cropper: {},
    img: this.props.usuarios.item.avatar ? this.props.usuarios.item.avatar : "",
  };

  handleDrop = (accepted, rejected) => {
    this.setState({ accepted, rejected });
    if (this.state.rejected.length > 0) {
      this.props.openError(
        "Foto não permitida. São aceitas apenas imagens com extensão .jpg e .png"
      );
      return;
    }
    const image = document.getElementById("image-crop");
    const cropper = new Cropper(image, {
      aspectRatio: 1 / 1,
      viewMode: 1,
    });
    this.setState({ cropper: cropper });
  };

  handleClean = () => {
    this.setState({ accepted: [] });
  };

  handleSave = () => {
    const oldFile = this.state.accepted[0];
    const binStr = atob(
      this.state.cropper
        .getCroppedCanvas()
        .toDataURL(oldFile.type)
        .split(",")[1]
    );
    const arr = new Uint8Array(binStr.length);
    for (let i = 0; i < binStr.length; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    const file = new File([arr], oldFile.name, { type: oldFile.type });

    let formData = new FormData();
    formData.append("avatar", file);

    this.setState({
      accepted: [],
      rejected: [],
      cropper: {},
      img: URL.createObjectURL(file),
    });

    api
      .post(`/users/${this.props.usuarios.item.id}/avatar`, formData)
      .then((data) => {
        this.props.openSuccess("Upload de foto completado com sucesso.");

        this.props.getPermissions();

        apiChat
          .get(`/customer?chat_key=${this.props.permissions.chat_key}`)
          .then((customer) => {
            const userInsert = {
              avatar: data.data.avatar,
              customer: customer.data._id,
              id_in_customer: data.data.id,
            };

            apiChat.put("user-picture", userInsert);
          })
          .catch((err) => {
            // TODO
          });
      })
      .catch((err) => {
        this.props.openError(
          "Ocorreu um erro no upload da foto. Por favor, tente novamente."
        );
      });
  };

  render() {
    const dropzoneRef = React.createRef();
    return (
      <Fragment>
        {this.state.accepted.length === 0 && (
          <div className="dropzone">
            <div
              className="img-preview"
              style={{ backgroundImage: `url(${this.state.img})` }}
            />
            <Dropzone
              ref={dropzoneRef}
              accept="image/jpeg, image/png"
              multiple={false}
              className="avatar"
              onDrop={(accepted, rejected) =>
                this.handleDrop(accepted, rejected)
              }
            />
            <button
              type="button"
              onClick={() => {
                dropzoneRef.current.open();
              }}
              className="botao-enviar-nova"
            >
              Enviar nova foto
            </button>
          </div>
        )}
        {this.state.accepted.length > 0 && (
          <Fragment>
            <div className="image-crop">
              <img
                src={this.state.accepted[0].preview}
                alt="Crop"
                id="image-crop"
              />
            </div>
            <div className="image-crop-controls mt2">
              <PrimaryButton onClick={() => this.handleSave()}>
                Salvar
              </PrimaryButton>
              <span className="mr1" />
              <DefaultButton onClick={() => this.handleClean()}>
                Cancelar
              </DefaultButton>
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  error: state.error,
  success: state.success,
  usuarios: state.usuarios,
  permissions: state.permissions,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...ErrorActions, ...SuccessActions, ...PermissionsActions },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Photo);



// WEBPACK FOOTER //
// ./src/components/Forms/Usuarios/photo.js